var render, staticRenderFns
import script from "./design.vue?vue&type=script&lang=ts"
export * from "./design.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports